"use strict";
function _interopDefault(ex) {
  return ex && "object" == typeof ex && "default" in ex ? ex.default : ex;
}
Object.defineProperty(exports, "__esModule", { value: !0 });
var createEmotion = _interopDefault(require("create-emotion")),
  _createEmotion = createEmotion(),
  flush = _createEmotion.flush,
  hydrate = _createEmotion.hydrate,
  cx = _createEmotion.cx,
  merge = _createEmotion.merge,
  getRegisteredStyles = _createEmotion.getRegisteredStyles,
  injectGlobal = _createEmotion.injectGlobal,
  keyframes = _createEmotion.keyframes,
  css = _createEmotion.css,
  sheet = _createEmotion.sheet,
  cache = _createEmotion.cache;
(exports.flush = flush),
  (exports.hydrate = hydrate),
  (exports.cx = cx),
  (exports.merge = merge),
  (exports.getRegisteredStyles = getRegisteredStyles),
  (exports.injectGlobal = injectGlobal),
  (exports.keyframes = keyframes),
  (exports.css = css),
  (exports.sheet = sheet),
  (exports.cache = cache);



//////////////////
// WEBPACK FOOTER
// ./~/emotion/dist/emotion.cjs.prod.js
// module id = 326
// module chunks = 35783957827783